var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05 2.35C3.55883 2.35 2.35 3.55883 2.35 5.05V14.95C2.35 16.4412 3.55883 17.65 5.05 17.65H14.95C16.4412 17.65 17.65 16.4412 17.65 14.95V9.55H14.5C12.2632 9.55 10.45 7.73675 10.45 5.5V2.35H5.05ZM11.8 3.30459L16.6954 8.2H14.5C13.0088 8.2 11.8 6.99117 11.8 5.5V3.30459ZM1 5.05C1 2.81325 2.81325 1 5.05 1H11.125C11.304 1 11.4757 1.07112 11.6023 1.1977L18.8023 8.3977C18.9289 8.52429 19 8.69598 19 8.875V14.95C19 17.1868 17.1868 19 14.95 19H5.05C2.81325 19 1 17.1868 1 14.95V5.05Z",
    fill: "#3EC1CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7002 10.5627C3.7002 10.1899 4.0024 9.8877 4.3752 9.8877H10.5627C10.9355 9.8877 11.2377 10.1899 11.2377 10.5627C11.2377 10.9355 10.9355 11.2377 10.5627 11.2377H4.3752C4.0024 11.2377 3.7002 10.9355 3.7002 10.5627Z",
    fill: "#3EC1CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7002 13.9377C3.7002 13.5649 4.0024 13.2627 4.3752 13.2627H8.3127C8.68549 13.2627 8.9877 13.5649 8.9877 13.9377C8.9877 14.3105 8.68549 14.6127 8.3127 14.6127H4.3752C4.0024 14.6127 3.7002 14.3105 3.7002 13.9377Z",
    fill: "#3EC1CF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.eae6440eebc064481774e79f2a044339.svg";
export { ForwardRef as ReactComponent };